export const staticPageMeta = {
  '/about': {
    title: '关于 Parentool 工具站 - 免费在线办公工具',
    description: '了解 Parentool 工具站的定位、工具范围和本地处理原则。'
  },
  '/privacy': {
    title: '隐私政策 - Parentool 工具站',
    description: 'Parentool 工具站隐私政策，说明文件、本地处理、跨设备剪切板和基础访问日志的处理方式。'
  },
  '/contact': {
    title: '联系我们 - Parentool 工具站',
    description: '联系 Parentool 工具站，反馈工具问题、功能建议和站点合作事项。'
  },
  '/disclaimer': {
    title: '免责声明 - Parentool 工具站',
    description: 'Parentool 工具站免责声明，说明在线工具处理结果、文件风险和健康投资相关内容边界。'
  },
  '/search-indexing': {
    title: '搜索引擎收录指引 - Parentool 工具站',
    description: '查看 Parentool 在 Google Search Console 和百度搜索资源平台上的收录、sitemap 提交和重点页面提交流程。'
  },
  '/app/toolmate/privacy': {
    title: '隐私政策 | 简单工具箱 ToolMate',
    description: '查看简单工具箱 ToolMate 的隐私政策，了解本地存储、通知权限和支持联系方式。'
  },
  '/app/toolmate/terms': {
    title: '用户协议 | 简单工具箱 ToolMate',
    description: '查看简单工具箱 ToolMate 的用户协议，了解应用用途、记录责任、功能变更和支持邮箱。'
  },
  '/app/toolmate/support': {
    title: '技术支持 | 简单工具箱 ToolMate',
    description: '查看简单工具箱 ToolMate 的技术支持页面，了解功能范围、支持邮箱和反馈说明。'
  }
} as const

export type StaticPagePath = keyof typeof staticPageMeta
